import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { fonts } = redesignTheme;

export const useCompassSectionsStyles = makeStyles(() => ({
  pyramidImage: {
    maxWidth: '100%',
    height: 'auto',
    maxHeight: 304,
    objectFit: 'contain',
  },
  personalityChart: {
    width: '100%',
    maxWidth: 399,
  },
  personalityTitle: {
    fontFamily: fonts.gothicSemiBold,
    fontSize: 15,
    marginBottom: 4,
  },
  talentsChart: {
    width: '100%',
    maxWidth: 440,
    height: 320,
    display: 'flex',
    justifyContent: 'center',
  },
  podiumWrap: {
    width: '100%',
    maxWidth: 440,
  },
}));
